module.exports = __webpack_public_path__ + "img/te-location.d9268891.svg";